(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* globals $, google, universities */
var Maps = function Maps() {
  _classCallCheck(this, Maps);

  var self = this;
  this.mapPartner = null;
  this.geocoder = null;
  this.infoWindow = null;
  this.markers = [];
  this.nbResult = 0;
  $('#submitFilter').on('click', function (ev) {
    ev.preventDefault();
    return false;
  }).on('pointerup', function () {
    self.filterSubmit();
  });
  $('.full-block-maps-partner').find('.filter-init a').on('click', function (ev) {
    ev.preventDefault();
    return false;
  }).on('pointerup', function () {
    self.filterReset();
  });
  this.initMap();
};

Maps.prototype = {
  initMap: function initMap() {
    this.geocoder = new google.maps.Geocoder();
    this.mapPartner = new google.maps.Map(document.getElementById('mapsPartner'), {
      center: {
        lat: 44,
        lng: 0
      },
      gestureHandling: 'cooperative',
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
      zoom: 2
    });

    if (typeof universities !== 'undefined' && universities.length > 0) {
      this.args = {
        map: this.mapPartner,
        optimized: false
      };
      this.bounds = new google.maps.LatLngBounds();
      this.infoWindow = new google.maps.InfoWindow({
        content: ''
      });

      for (var i = 0; i < universities.length; i = i + 1) {
        var university = universities[i];
        this.args.university = university;

        if (typeof university.type !== 'undefined') {
          var url = void 0;

          if (university.type === 'red') {
            url = '/bundles/kedgecore/images/svg/pin-red.svg';
          } else {
            url = '/bundles/kedgecore/images/svg/pin-green.svg';
          }

          this.args.icon = {
            url: url,
            scaledSize: new google.maps.Size(28, 39),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14, 39),
            size: new google.maps.Size(28, 39)
          };
        }

        if (!university.lat || !university.lng) {
          this.codeAddress(university, this.geometryReturn);
        } else {
          this.args.position = new google.maps.LatLng({
            lat: university.lat,
            lng: university.lng
          });
          this.addMarker();
        }
      }

      this.mapPartner.fitBounds(this.bounds);
      $('.mapNbResult').html(this.nbResult);
    }

    this.filterSubmit();
  },
  geometryReturn: function geometryReturn(data) {
    if (data.geometry) {
      this.args.position = data.geometry.location;
      this.addMarker();
    }
  },
  addMarker: function addMarker() {
    var self = this,
        marker = new google.maps.Marker(this.args);
    this.markers.push(marker);
    this.bounds.extend(marker.getPosition());
    this.nbResult = this.nbResult + 1;
    marker.addListener('click', function () {
      self.infoWindow.setContent(self.updateInfoWindowContent(marker));
      self.infoWindow.open(self.mapPartner, marker);
    });
  },
  updateInfoWindowContent: function updateInfoWindowContent(marker) {
    var content = '';
    content += '<div class="infoWindow font-din">';
    content += '<p class="text-extra-small no-margin">' + marker.university.city + '</p>';
    content += '<p class="text-large no-margin"><strong>' + marker.university.university + '</strong></p>';
    content += '<hr class="dotted-line" />';
    content += '<p class="text-small no-margin">' + marker.university.programme + '</p>';
    content += '<p class="text-small no-margin"><b>' + marker.university.twice_diplome + '</b></p>';
    content += '<p class="text-small no-margin"><a href="' + marker.university.link + '">' + marker.university.link + '</p>';
    content += '</div>';
    return content;
  },
  codeAddress: function codeAddress(university, callback) {
    this.geocoder.geocode({
      'address': university.address
    }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        callback({
          Status: 'OK',
          geometry: results[0].geometry
        });
      } else {
        console.log('Geocode was not successful for the following reason: ' + status, university);
        return false;
      }
    });
  },
  filterSubmit: function filterSubmit() {
    var self = this;
    var countries = $('#pays').val(),
        programs = $('#programme').val();
    this.nbResult = 0;
    this.bounds = new google.maps.LatLngBounds();

    for (var a in this.markers) {
      if (countries == null && programs == null) {
        this.markers[a].setVisible(true);
        this.bounds.extend(this.markers[a].getPosition());
        this.nbResult = this.nbResult + 1;
      } else {
        var programMarker = this.markers[a].university.programme.split(', ');

        if (countries != null && countries.indexOf(this.markers[a].university.country) === -1 && programs == null) {
          this.markers[a].setVisible(false);
        } else if (programs != null && !self.findOne(programs, programMarker) && countries == null) {
          this.markers[a].setVisible(false);
        } else if (countries != null && programs != null && (countries.indexOf(this.markers[a].university.country) === -1 || !self.findOne(programs, programMarker))) {
          this.markers[a].setVisible(false);
        } else {
          this.markers[a].setVisible(true);
          this.bounds.extend(this.markers[a].getPosition());
          this.nbResult = this.nbResult + 1;
        }
      }
    }

    this.mapPartner.fitBounds(this.bounds);
    $('.mapNbResult').html(this.nbResult);
    var odd = 'odd';
    $('#universities .university').each(function () {
      var $this = $(this);
      var country = $this.data('country');
      var program = $this.data('program');
      $this.removeClass('even odd');

      if (country.length === 0 || program.length === 0) {
        $this.hide();
      } else if (countries === null && programs === null) {
        $this.show();
        $this.addClass(odd);
        odd = odd === 'odd' ? 'even' : 'odd';
      } else {
        program = program.split('|');

        if (countries !== null && countries.indexOf(country) === -1 && programs === null) {
          $this.hide();
        } else if (programs !== null && !self.findOne(programs, program) && countries === null) {
          $this.hide();
        } else if (countries !== null && programs !== null && (countries.indexOf(country) === -1 || !self.findOne(programs, program))) {
          $this.hide();
        } else {
          $this.show();
          $this.addClass(odd);
          odd = odd === 'odd' ? 'even' : 'odd';
        }
      }
    });
  },

  /**
   * @description determine if an array contains one or more items from another array.
   * @param {array} haystack the array to search.
   * @param {array} arr the array providing items to check for in the haystack.
   * @return {boolean} true|false if haystack contains at least one item from arr.
   */
  findOne: function findOne(haystack, arr) {
    return arr.some(function (v) {
      return haystack.indexOf(v) >= 0;
    });
  },
  filterReset: function filterReset() {
    $('.full-block-maps-partner select option:selected').each(function () {
      $(this).prop('selected', false);
    });
    $('.full-block-maps-partner select').multipleSelect('refresh');
    this.filterSubmit();
  }
};
window.Maps = Maps;

},{}]},{},[1]);
